import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { iframeUtils } from "@kaihong/utils/lib/iframePostMessage";
import dataJson from "@/../public/data.json";

const prefix = "superDeviceTemplateDetail-spatialinformation";
import { getEnable, goLogin } from "@/utils";
import "./index.less";

function SpatialInformation() {
  const { super_device_template_detail } = dataJson;
  const { id } = useParams();

  const [iframeUrl, setIframeUrl] = useState("");
  const enableQuery = getEnable() ? "&enable=true" : "";
  useEffect(() => {
    const origin = window.location.origin;
    setIframeUrl(`${origin}/sub-app/khlinks/#/khlinks/external/Instance/${id}?type=space&inIframe=true${enableQuery}`);
    iframeUtils.onMessage("login", (data) => {
      console.log("监听iframe页面发送的消息", data);
      goLogin();
    });
  }, [id]);

  return (
    <div className={prefix}>
      <div className={`${prefix}-inner`}>
        <div className={`${prefix}-header`}>
          <div className={`${prefix}-header-text`}>
            <div className={`${prefix}-header-title`}>{super_device_template_detail.menu[2].label}</div>
            <div className={`${prefix}-header-tip`}>
              {super_device_template_detail.menu[2].label + super_device_template_detail.desc_tip}
            </div>
          </div>
        </div>
        <div className={`${prefix}-content`}>
          <div className={`${prefix}-content-title`}>
            <iframe src={iframeUrl} style={{ width: "100%", height: "100%" }} name="login" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SpatialInformation;
